import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { unstable_HistoryRouter, useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const IncomeTaxSlabList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [apiStatus, SetApiStatus] = useState(undefined);
  const [searchTerm, setSearchTerm] = useState("");
  const [ITSlabListingData, setITSlabListingData] = useState([])
  useEffect(() => {
    dispatch(updateNavbarHeading("Income Tax Slab"));
    fetchGetData();
  }, []);

  const columns = {
    FYFromDate: { text: "From Year", align: "center", visible: true },
    FYToDate: { text: "To Year", align: "center", visible: true },
    TaxRebateLimit: { text: "TaxRebate Limit", align: "end", visible: true },
    TaxRebateExcemtion: { text: "TaxRebate Excemtion", align: "end", visible: true },
    TaxEducationCESS: { text: "TaxRebate CESS", align: "end", visible: true },
  };


  const fetchGetData = async () => {
    SetApiStatus(undefined)
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}income-slab`);

      SetApiStatus(response?.status)
      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        setITSlabListingData(cleanedData?.map(el => ({ ...el, canBeDelete: 0 })).reverse())
      }
    } catch (error) {
      console.log("Fetching Error IT Slab Get APi", error);
    }
  };



  const handleAddNew = () => {
    navigate(`/rujul/hrm/income-tax-slab/add`)
  }
  const handleEdit = (data) => {

    navigate(`/rujul/hrm/income-tax-slab/edit/${data?.ID}`)
  }
  return (<div className="container-fluid" id="skill_section">
    <div className=" rounded bg-white" id="skill-table-area">
      <div className="row mt-2">
        <Dynamic_PR_table
          data={ITSlabListingData}
          columns={columns}
          itemsPerPage={10}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          isSrNoRequired={false}
          showIcon1={true}
          showIcon2={true}
          isActionRequired={true}
          isApiStatus={apiStatus}
          isRequiredStatus={true}
          isAddNewBtnRequired={true}
          isSorting={true}
          showIcon3={false}
          showIcon4={false}
          showIcon5={false}
          handleIcon1={handleEdit}
          // handleIcon2={handleDeleteModal}
          handleAddNew={handleAddNew}
          add
          more
          function
          icons={{
            Icon1: <i class="bi bi-pencil-square icons"></i>,
            Icon1Text: " Edit",
            Icon2: <i class="bi bi-trash-fill icons"></i>,
            Icon2Text: "Delete",
            Icon2Flag: "canBeDelete",
            Icon3: <i class="bi bi-eye-fill icons"></i>,
            Icon4: <i class="bi bi-plus-square icons"></i>,
            Icon4Text: " Add Sub-Contractor",
          }}
        />
      </div>
    </div>
  </div>)
};

export default IncomeTaxSlabList;
